var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { COLORS, FONT } from '../../../constants';
import { cloneElementWithCss } from '../../shared/utils';
var activeItem = {
  color: COLORS.blues.primary,
  borderBottom: "3px solid " + COLORS.blues.primary,
  '&:hover': {
    color: COLORS.blues.primary,
    borderBottom: "3px solid " + COLORS.blues.primary
  }
};
var hoverItem = {
  color: COLORS.grays.dark,
  borderBottom: "3px solid " + COLORS.grays.cardBorder
};

var item = __assign(__assign({
  display: 'inline-block',
  color: COLORS.grays.dark,
  fontWeight: 'bold',
  letterSpacing: 0.3,
  padding: '6px 0 15px 0',
  margin: '0 12px',
  borderBottom: "3px solid " + COLORS.white
}, FONT.sizes.h5), {
  '&:hover': hoverItem,
  '&:first-of-type': {
    marginLeft: 0
  },
  '&:last-of-type': {
    marginRight: 0
  }
});

var Item = function Item(_a) {
  var _b = _a.active,
      active = _b === void 0 ? false : _b,
      children = _a.children;
  var styles = [item];
  if (active) styles.push(activeItem);
  return cloneElementWithCss(children, styles);
};

export default Item;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/tabs/item.js
// module id = 1109
// module chunks = 0